import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import ArticleArcsPage from './views/ArticleArcs';
import ContentsPage from './views/Contents';
import FactAnchorsPage from './views/FactAnchors';
import HotPotsPage from './views/HotPots';
import IpKernelsPage from './views/IpKernels';
import SeedPlansPage from './views/SeedPlans';
import ScriptArcsPage from './views/ScriptArcs';
import TopicLensPage from './views/TopicLens';

export const ipCreatorRoutes = [
  {
    path: 'ip-creator',
    name: '内容中心',
    icon: 'bulb',
    children: [
      {
        index: true,
        element: <Navigate to="contents" replace />,
      },
      {
        path: 'ip-kernels',
        name: '创作内核',
        icon: 'user',
        ownerAdminOnly: true,
        element: <IpKernelsPage />,
      },
      {
        path: 'seed-plans',
        name: '创作规划',
        icon: 'calendar',
        element: <SeedPlansPage />,
      },
      {
        path: 'hot-pots',
        name: '热点采集',
        icon: 'fire',
        element: <HotPotsPage />,
      },
      {
        path: 'fact-anchors',
        name: '材料搜集',
        icon: 'audit',
        element: <FactAnchorsPage />,
      },
      {
        path: 'topic-lens',
        name: '选题策划',
        icon: 'read',
        element: <TopicLensPage />,
      },
      {
        path: 'article-arcs',
        name: '文章创作',
        icon: 'picture',
        element: <ArticleArcsPage />,
      },
      {
        path: 'script-arcs',
        name: '视频脚本',
        icon: 'fileText',
        element: <ScriptArcsPage />,
      },
      {
        path: 'contents',
        name: '创作统计',
        icon: 'appstore',
        element: <ContentsPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
